import React, { Component } from 'react';
import SortIcon from './SortIcon';
import { withStyles } from '@material-ui/core/styles';
var styles = {
  wrapper: {
    cursor: 'pointer'
  },
  label: {
    display: 'inline-block',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%',
    '& > label': {
      cursor: 'pointer'
    }
  },
  sort: {
    display: 'inline-block',
    width: '100%'
  }
};

var HeaderCell = function HeaderCell(props) {
  var sort = function sort() {
    if (props.filterCriteria) {
      var asc = props.filterCriteria.asc === 'asc' ? 'desc' : 'asc';
      return function () {
        return props.onClick({
          sort: props.appId,
          asc: asc
        });
      };
    }

    return function () {
      return null;
    };
  };

  var renderSortIcon = function renderSortIcon() {
    if (props.filterCriteria && props.appId === props.filterCriteria.sort) {
      return React.createElement("span", {
        className: props.classes.sort
      }, React.createElement(SortIcon, {
        asc: props.filterCriteria.asc
      }));
    }
  };

  return React.createElement("div", {
    className: props.classes.wrapper,
    onClick: sort(),
    "data-testid": "headerCell"
  }, React.createElement("span", {
    className: props.classes.label
  }, React.createElement("label", {
    title: props.children
  }, props.children)), renderSortIcon());
};

export default withStyles(styles)(HeaderCell);